/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';

/**
 * Internal scripts
 */
import './collapse';
import './dropdown';
import './swiper';
import './button';
import './modal';
import './anchor';
import './mapbox';
import './aos';
import './wonen/readmore';
import './wonen/brochure';

$(document).ready( () => {
  // Scrolldown
  $('.scroll-down').each(function() {
    $(this).on('click', function() {
      $('html, body').animate({
        scrollTop: $('.page-header--home').outerHeight(),
      });
    });
  });
});
